import React from 'react';

export const LazyPostAssessmentPage = React.lazy(() =>
  import('./PostAssessmentPage').then((module) => ({
    default: module.PostAssessmentPage,
  }))
);
